<template>
    <div class="timeline">
        <div class="content">
            <Timeline mode="alternate">
                <Item class="item" v-for="(item,index) in list" :key="index">
                    <div class="b-bg"></div>
                    <div class="block">
                            <h3>{{item.title}}</h3>
                            <p>{{item.dec}}</p>
                        </div>
                </Item>
        </Timeline>
    </div>
    <div class="motion motion-scroll-bind">
        <img :src="tlDBg[0]" class="circle circle1" :style="{transform: `translate(${translateNum}px,${-translateNum}px)`}">
        <img :src="tlDBg[1]" class="circle circle2" :style="{transform: `translate(${translateNum}px,${translateNum}px)`}">
        <img :src="tlDBg[2]" class="circle circle3" :style="{transform: `translate(${-translateNum}px,${-translateNum}px)`}">
        <img :src="tlDBg[3]" class="circle circle4" :style="{transform: `translate(${translateNum}px`}">
    </div>
  </div>
</template>

<script>
import {Timeline } from 'ant-design-vue'
const tlDBg = [
    require('@assets/images/home/tl_1@2x.png'),
    require('@assets/images/home/tl_2@2x.png'),
    require('@assets/images/home/tl_3@2x.png'),
    require('@assets/images/home/tl_4@2x.png')
]
const {Item }  = Timeline;
const baseSy = 600;
export default {
    components:{
        Timeline,
        Item
    },
    props:{
        list:{
            type:Array,
            default(){
                return []
            }
        }
    },
    data(){
        return {
            translateNum:baseSy,
            tlDBg
        }
    },
    mounted(){
        document.addEventListener('scroll',this.setTranslate)
    },
    beforeDestroy(){
        document.removeEventListener('scroll',this.setTranslate)
    },
    methods:{
        setTranslate(e){
            const y = window.pageYOffset || window.scrollY;
            if(y > 400) {
                this.translateNum = baseSy - y + 400;
            } else {
                this.translateNum = baseSy;
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    .timeline {
        width: 100%;
        height: 588px;
        background: #fff;
        .content {
            display: flex;
            justify-content: center;
            position: relative;
            overflow: hidden;
            z-index: 2;
        }
        .item {
            .b-bg {
                position: relative;
                background: url('~@assets/images/home/timeline_block@2x.png') no-repeat;
                width: 100%;
                height: 145px;
                background-size: cover;
                background-position: center;
                color: #333333;
                
            }
            .block {
                position: absolute;
                padding: 25px;
                @include Transition;
                @media #{$media} {
                    padding: 25px 16px;
                }
                h3 {
                    font-size: 20px;
                    line-height: 28px;
                    margin-bottom: 6px;
                }
                p {
                    line-height: 20px;
                }
            }
        }
    }
    .motion {
        position: absolute;
        left: 0;
        top: -160px;
        width: 100%;
        height: 588px;
        z-index: 0;
        overflow: hidden;
        .circle {
            position: absolute;
            z-index: -1;
            transition: all .5s;
            &.circle1 {
                bottom: -175px;
                left: -39px;
                width: 563px;
            }
            &.circle2 {
                top: -128px;
                right: -200px;
                width: 674px;
            }
            &.circle3 {
                top: -230px;
                right: 200px;
                width: 526px;
            }
            &.circle4 {
                top: 199px;
                right: 49px;
                width: 674px;
            }
        }
    }
</style>

<style lang="scss">
    .timeline {
        
        .ant-timeline-alternate {
            height: 386px;
            padding-right:102px;
            @include Flex;
            .ant-timeline-item {
                padding: 0;
                width: 102px;
                @include Transition;
                @media #{$media} {
                    width: 94px;
                }
            }
            .ant-timeline-item-last .ant-timeline-item-tail {
                display: inline-block;
                width: 200%;
            }
            .ant-timeline-item-tail {
                left: 0;
                width: 100%;
                top: 50%;
                height: auto;
                border-top: 1px solid #C0C0C0;
            }
            .ant-timeline-item-head {
                top: 50%;
                left: auto;
                right:0;
                margin-right: -9px;
                margin-top: -9px;
                z-index: 2;
                width: 20px;
                height: 20px;
                background:url('~@assets/images/home/tl_icon@2x.png') no-repeat;
                background-size: 100% auto;
                border-color: transparent;
            }
            .ant-timeline-item-left .ant-timeline-item-content{
               text-align: left;
                margin: 0 0  18px 0;
                top:0;
                left: 0;
                width: 200%;
                height: 50%;
                .b-bg {
                    position: absolute;
                    bottom: 10px;
                }
                .block {
                    bottom: 20px;
                }
            }
            .ant-timeline-item-right .ant-timeline-item-content{
                text-align: left;
                top:50%;
                width: 200%;
                margin: 0 0 0 0;
                left: 0;
                .b-bg {
                    top:10px;
                    transform: rotate(180deg);
                }
                .block {
                    top: 20px;
                }
            }
            .ant-timeline-item-content {
                text-align: left;
                margin: 0 0  18px 0;
                top:0;
                left: 0;
                width: 200%;
                height: 50%;
                
            }
        }
    }
    
</style>

